import type { ComponentType } from 'react';
import React, { Component } from 'react';
import { publish } from '@alfa-bank/site-event-bus';
import { Subscriber } from '@alfa-bank/site-event-bus/subscriber';

const events = [
    {
        name: 'on_select_city_by_footer',
        propKeys: [
            {
                dataKey: 'actionCreatedBy',
                propKey: 'emittedBy',
            },
            {
                dataKey: 'show',
                propKey: 'isShow',
            },
            {
                dataKey: 'geo',
                propKey: 'geo',
            },
        ],
    },
];

export const withChangeCities = <P extends object>(
    WrappedComponent: ComponentType<P>
): ComponentType<P> => {
    class HOC extends Component<P> {
        handlerOnChangeCity = (geo: object): void => {
            publish('show_cities_popup', {
                actionCreatedBy: 'on_select_city_by_footer',
                show: true,
                geo,
            });
        };

        render() {
            return (
                <Subscriber events={events}>
                    <WrappedComponent
                        {...(this.props as P)}
                        onChangeCity={this.handlerOnChangeCity}
                    />
                </Subscriber>
            );
        }
    }

    return HOC;
};
